import { getAbsoluteAssetUrl } from '@/lib/site';

const DEFAULT_TITLE = 'Finlay';
const DEFAULT_DESCRIPTION =
  'Finlay helps teams hire faster with curated candidate shortlists and AI-powered screening.';
const DEFAULT_OG_IMAGE_PATH = '/og-image.png';

interface DocumentMetadataProps {
  title?: string;
  description?: string;
  imagePath?: string;
  /** When false, use `title` as-is instead of appending ` - Finlay`. */
  appendBrand?: boolean;
}

export const DocumentMetadata = ({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  imagePath = DEFAULT_OG_IMAGE_PATH,
  appendBrand = true,
}: DocumentMetadataProps) => {
  const isDefaultTitle = title === DEFAULT_TITLE;
  const documentTitle =
    isDefaultTitle || !appendBrand ? title : `${title} - Finlay`;
  const imageUrl = getAbsoluteAssetUrl(imagePath);

  return (
    <>
      <title>{documentTitle}</title>
      <meta name="description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Finlay" />
      <meta property="og:title" content={documentTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={documentTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
    </>
  );
};
